import { AnimatePresence } from "motion/react";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { AssistantDock } from "../shared/components/AssistantDock";
import { PageTransition } from "../shared/components/PageTransition";
import { ScrollToTop } from "../shared/components/ScrollToTop";
import { SiteHeader } from "../shared/components/SiteHeader";
import { PageAnalytics } from "../shared/components/PageAnalytics";
import { useAuth } from "../shared/auth/AuthContext";

const HomePage = lazy(() => import("../features/home/HomePage").then((module) => ({ default: module.HomePage })));
const KnowledgePage = lazy(() => import("../features/knowledge/KnowledgePage").then((module) => ({ default: module.KnowledgePage })));
const CasesPage = lazy(() => import("../features/cases/CasesPage").then((module) => ({ default: module.CasesPage })));
const ProjectPage = lazy(() => import("../features/projects/ProjectPage").then((module) => ({ default: module.ProjectPage })));
const StudentHomePage = lazy(() => import("../features/home/StudentHomePage").then((module) => ({ default: module.StudentHomePage })));
const TeacherDashboardPage = lazy(() => import("../features/teacher/TeacherDashboardPage").then((module) => ({ default: module.TeacherDashboardPage })));

export function App() {
  const location = useLocation();
  const { user, loading } = useAuth();
  const chromeHidden = location.pathname === "/" || location.pathname.startsWith("/login/");

  if (loading) return <div className="page-loader" aria-live="polite"><span className="skeleton" />正在准备页面...</div>;

  return (
    <>
      <ScrollToTop />
      <PageAnalytics />
      {!chromeHidden && <SiteHeader />}
      <main className="app-main">
        <Suspense fallback={<div className="page-loader" aria-live="polite"><span className="skeleton" />正在准备页面...</div>}>
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route element={<PageTransition />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/login/:role" element={<HomePage />} />
                <Route path="/student" element={<StudentHomePage />} />
                <Route path="/teacher" element={<TeacherDashboardPage />} />
                <Route path="/knowledge" element={<KnowledgePage />} />
                <Route path="/cases" element={<CasesPage />} />
                <Route path="/projects" element={!loading && user?.role !== "student" ? <Navigate to={user?.role === "teacher" ? "/teacher" : "/login/student"} replace /> : <ProjectPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </AnimatePresence>
        </Suspense>
      </main>
      {!chromeHidden && <AssistantDock />}
    </>
  );
}
